import * as React from 'react'

import MuiAvatar from '@material-ui/core/Avatar'

import genRngHex  from '../../utils/rng-hex'
import { Avatar } from '../organisms'

interface ProfileAvatarProps {
  img?: string
  name: string
  isOpenable?: boolean
}

const ProfileAvatar = ({ img, name }: ProfileAvatarProps) => {
  if (img) {
    return <Avatar photo={img} />
  }

  const bgColor = genRngHex(name)
  const initials = name ? name.split(' ').map(word => word.length && word[ 0 ].toUpperCase()) : ''

  return (
    <MuiAvatar style={{ background: bgColor }}>
      {initials[ 0 ] + (initials[ 1 ] || '')}
    </MuiAvatar>
  )
}

export default ProfileAvatar



// WEBPACK FOOTER //
// ./src/components/molecules/ProfileAvatar.tsx